<style scoped>
.bar {
  width: 100%;
  display: flex;
}
.reverse {
  flex-direction: row-reverse;
}
.bar .value {
  height: 100%;
}
.bar.blue .value {
  background: #2185f0;
}
.bar.green .value {
  background: #2ee6a8;
}
.bar.gray .value {
  background: rgba(255, 255, 255, 0.5);
}
.small {
  height: 2px;
}
.default {
  height: 3px;
}
.large {
  height: 4px;
}
</style>
<template>
  <div :class="classes" :style="styles" class="bar">
    <div class="value" :style="{width:value/maxValue*100+'%'}"></div>
  </div>
</template>
<script>
export default {
  props: {
    size: {
      validator(value) {
        return ["large", "default", "small"].indexOf(value) > -1;
      },
      default() {
        return "default";
      }
    },
    align: {
      validator(value) {
        return ["left", "right"].indexOf(value) > -1;
      },
      default() {
        return "left";
      }
    },
    color: {
      validator(value) {
        return ["blue", "green", "gray"].indexOf(value) > -1;
      },
      default() {
        return "blue";
      }
    },
    backgroundColor: {
      type: String,
      default() {
        return "rgba(255, 255, 255, 0.25)";
      }
    },
    isBackground: {
      type: Boolean,
      default: true
    },
    value: {
      validator(value) {
        if (isNaN(value)) {
          return false;
        }
        if (value < 0) {
          return false;
        }
        return true;
      },
      default: 0
    },
    maxValue: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {};
  },
  computed: {
    classes() {
      return [
        `${this.size}`,
        `${this.color}`,
        {
          reverse: this.align == "right"
        }
      ];
    },
    styles() {
      const style = {};
      if (this.isBackground) {
        style["backgroundColor"] = this.backgroundColor;
      }
      return style;
    }
  }
};
</script>
